
import { GET_REPAIR_VALUE_FAILURE, GET_REPAIR_VALUE_REQUEST, GET_REPAIR_VALUE_SUCCESS } from "./repairValueTypes";

const initialState = {
  loading: false,
  repairValue: [],
  error: "",
};

const getRepairValueReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPAIR_VALUE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REPAIR_VALUE_SUCCESS:
      return {
        loading: false,
        repairValue: action.payload,
        error: "",
      };
    case GET_REPAIR_VALUE_FAILURE:
      return {
        loading: false,
        repairValue: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

// const initialStateWithPagination = {
//   loading: false,
//   documentType: [],
//   error: "",
// };

// const getDocumentTypeWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         documentType: action.payload,
//         error: "",
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         documentType: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

export { getRepairValueReducer,
    //  getDocumentTypeWithPaginationReducer 
    };
